// extracted by mini-css-extract-plugin
export default {"loads-menu":"LoadsMenu_loads-menu__FHZJH","active":"LoadsMenu_active__t9AtA"};